class Mis {

    constructor(apiService = null) {
        this.obj_name = 'mis';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            { condition: formData.processing_start_date === '', message: formData.mission_type == 1 ? '請選擇執行日期' : '請選擇執行開始日期' },
            { condition: ( formData.mission_type === 2 && formData.processing_end_date === '' ), message:  '請選擇執行結束日期' },
            { condition: formData.location === -1 , message: '請選擇執行地點' },
            { condition: formData.mission_name === '', message: '請輸入任務名稱' },
            { condition: formData.mission_content === '', message: '請輸入任務內容' },
            { condition: formData.assign.length <= 0, message: '請指派人員' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // API 方法
    //任務 | 101搜尋任務列表(分類)
    async getMissionByTypeAndKeywordWithPage(parameter) {
        return this.callApi('get', 'getMissionByTypeAndKeywordWithPage', parameter);
    }
    //任務 | 102新增任務
    async addMission(parameter, progressEvent = null) {
        return this.callApi('post', 'addMission', parameter, progressEvent);
    }
    //任務 | 103更新任務
    async updMission(parameter, progressEvent = null) {
        return this.callApi('post', 'updMission', parameter, progressEvent);
    }
    //任務 | 104刪除任務
    async delMission(parameter) {
        return this.callApi('delete', 'delMission', parameter );
    }
    //任務 | 105搜尋任務列表
    async getMissionAllByTypeAndKeywordWithPage(parameter) {
        return this.callApi('get', 'getMissionAllByTypeAndKeywordWithPage', parameter);
    }
    //任務 | 106取得任務詳細資料
    async getMissionDetailByMissionId(parameter) {
        return this.callApi('get', 'getMissionDetailByMissionId', parameter);
    }
    //任務 | 107更新任務人員
    async addOrDelMissionAssignedByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrDelMissionAssignedByJson', parameter , progressEvent);
    }
    //任務 | 107更新任務人員
    async addOrDelMissionAssignedByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrDelMissionAssignedByJson', parameter , progressEvent);
    }
    //任務 | 108完成任務
    async updMissionAssignedCompleteByAccount(parameter, progressEvent = null) {
        return this.callApi('post', 'updMissionAssignedCompleteByAccount', parameter , progressEvent);
    }
    //任務 | 109取得今日任務
    async getMissionTodayByAccount(parameter) {
        return this.callApi('get', 'getMissionTodayByAccount', parameter);
    }
}
export default Mis;